<template>
  <section>
    <div class="user-main">
      <div class="quickOrder flex ju-be">
        <div class="goodsList">
          <div class="title flex ju-be">
            <div class="zujiantitle">快速下单({{product_list.total}})</div>
            <div class="usearch">
              <input type="text" placeholder="商品名称/关键词" class="layui-input" v-model="keyword" />
              <button type="primary" @click="searchgoods" class="layui-btn layui-btn-sm">搜索</button>
            </div>
          </div>
          <div
            class="goodsItem_quick flex ju-be"
            v-for="(item,index) in product_list.data"
            :key="index"
          >
            <div class="goodsInfo flex">
              <a  :href="'product/'+item.id+'.html'"  target="_blank" rel="noopener noreferrer">
                <img :src="item.indexpic" alt class="goodsimg" />
              </a>
              <div class="goodsDetail flex">
                <p class="goodsname ellipsis-2">{{item.title}}</p>
                <div class="shopname ellipsis" v-if="item.showsign">
                  <span>{{item.issign?'签约商品':'普通商品'}}</span>
                </div>
                <p class="marque">{{item.specname}}</p>
                <p class="price">￥{{item.price}}</p>
              </div>
            </div>
            <el-button type="primary" @click="addcar(item)">加入购物车</el-button>
            <!-- <el-input-number v-model="item.num" :min="1" :max='1000' label="描述文字" @change="changeNum(item)"></el-input-number> -->
          </div>
          <el-pagination
            class="fenye"
            background
            layout="prev, pager, next"
            :page-size="~~product_list.per_page"
            @current-change="currentPage"
            :total="product_list.total"
          ></el-pagination>
        </div>
        <div class="selectedGoods">
          <div class="title">商品清单</div>
          <div class="goodList">
            <div v-for="(item,index) in carlist.shoplist" :key="index">
              <div
                class="goodsItem_quick flex ju-be"
                v-for="(item_i) in item.items"
                :key="item_i.id"
              >
                <div class="goodsDetail flex">
                  <a
                    :href="'product/'+item_i.productid+'.html'"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img :src="item_i.indexpic" alt class="goodsimg" />
                  </a>

                  <div class="goodsInfo">
                    <p class="goodsname">{{item_i.title}}</p>
                    <p class="marque">{{item_i.specname}}</p>
                    <p class="price color-primary">￥{{item_i.price}}</p>
                    <el-input-number
                      v-model="item_i.num"
                      :min="1"
                      :max="1000"
                      label
                      size="mini"
                      @change="changeNum(item_i)"
                    ></el-input-number>
                  </div>
                </div>
                <!-- <span class="num">*{{item_i.num}}</span> -->
              </div>
            </div>
          </div>
          <div class="jiesuan">
            <div class="num_price flex ju-be">
              <span class="goodsnum">共{{carlist.cartnum}}件商品</span>
              <span class="color-primary">￥{{carlist.total}}</span>
            </div>

            <router-link to="/jiesuan">
              <button type="primary">去结算</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "Order",
  data() {
    return {
      carlist: {},
      keyword: "",
      num1: 1,
      page: 1,
      carnum: "",
      product_list: {}
    };
  },
  watch: {
    carnum() {
      eventBus.$emit("changecarnum", this.carnum);
    }
  },
  props: {},
  methods: {
    searchgoods() {
      this.getOrderList();
    },
    // 分页
    currentPage(e) {
      this.page = e;
      this.getOrderList();
    },
    async changeNum(item) {
      console.log(item);
      let res = await this.$fetch("Cart/edit", {
        body: {
          productid: item.productid,
          num: item.num
        }
      });
      if (res) {
        this.$message({ message: "添加成功", type: "success" });
        this.carnum = res;
        this.getCarlist();
      }
    },
    // 
    // 加入购物车
    async addcar(item) {
      console.log(item);
      if (item.showsign && !item.issign) {
        this.$alert("非签约产品，请勿下单", "温馨提示", {
          confirmButtonText: "继续加入购物车",
          callback: async action => {
            let res = await this.$fetch("Cart/add", {
              body: {
                productid: item.id,
                num: 1
              }
            });
            if (res) {
              this.$message({ message: "添加成功", type: "success" });
              this.carnum = res;
              this.getCarlist();
            }
          }
        });
      } else {
        let res = await this.$fetch("Cart/add", {
          body: {
            productid: item.id,
            num: 1
          }
        });
        if (res) {
          this.$message({ message: "添加成功", type: "success" });
          this.carnum = res;
          this.getCarlist();
        }
      }
    },
    // 获取购物车列表
    async getCarlist() {
      console.log("重新请求数据");
      let res = await this.$fetch("Cart/cartinfo", {});
      console.log("res", res);
      if (res) {
        this.carlist = res;
      }
    },
    // 获取商品列表
    async getOrderList() {
      let product_list = await this.$fetch("Shop/productlist", {
        body: {
          page: this.page,
          pagesize: 5,
          keyword: this.keyword
        }
      });
      for (let i = 0; i < product_list.data.length; i++) {
        product_list.data[i]["num"] = 1;
      }
      this.product_list = product_list;
      console.log("product_list", product_list);
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key == 13) {
          this.searchgoods();
        }
      };
    }
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.getOrderList();
    this.getCarlist();
  }
};
</script>
<style lang='scss' scoped>
.user-main {
  margin-top: 0;
}
.quickOrder {
  align-items: flex-start;
  .goodsList {
    width: 640px;
    .title {
      overflow: hidden;
      margin-top: 20px;
      .usearch {
        margin: 20px 0;
      }
    }

    .goodsItem_quick {
      width: 580px;
      margin-top: 20px;
      padding-bottom: 40px;
      border-bottom: 1px solid #eeeeee;
      .goodsInfo {
        .goodsimg {
          width: 100px;
          height: 100px;
        }
        .goodsDetail {
          flex-direction: column;
          justify-content: space-around;
          height: 100px;
          font-size: 14px;
          color: #3c3c3c;
          // line-height: 20px;
          align-items: flex-start;
          margin-left: 20px;
          p {
            margin: 0;
          }
          .price {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(243, 153, 10, 1);
          }
        }
      }
      .el-input-number {
        width: 120px;
        input {
          width: 100%;
          padding: 0;
        }
        .el-input-number__decrease:hover .el-input-number {
          border-color: red;
        }
      }
    }
  }
  .selectedGoods {
    width: 350px;
    .title {
      width: 290px;
      margin: auto;
      margin-top: 20px;
    }
    .jiesuan {
      width: 290px;
      margin: auto;
      .num_price {
        font-size: 14px;
      }
      button {
        width: 100%;
        height: 50px;
        margin-top: 10px;
      }
      position: absolute;
      bottom: 0;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0%);
    }
    width: 350px;
    height: 890px;
    position: relative;
    border-left: 20px solid #f5f5f5;
    .goodList {
      height: 700px;
      overflow-y: auto;

      .goodsItem_quick {
        width: 290px;
        margin: auto;
        margin-top: 30px;
        color: #3c3c3c;
        font-size: 12px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 30px;
        .goodsimg {
          width: 70px;
          height: 70px;
        }
        .goodsInfo {
          width: 180px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 15px;
          p {
            margin: 0;
          }
          .price {
            font-size: 14px;
            font-weight: bold;
            margin: 5px 0;
          }
        }
      }
      .num {
        font-size: 12px;
        color: #666666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/quickOrder.vue